
<!-- Vertical stepper -->

<fuse-alert [type]="'error'" *ngIf="basicPatientInfo.invalid" class="my-3">
    <span fuseAlertTitle>Lipsesc date,sau datele introduse contin erori.</span>
    Corectati / completati datele introduse apoi butonul de finalizare se va activa.
</fuse-alert>

<fuse-alert [type]="'success'" *ngIf="!basicPatientInfo.invalid" class="my-3">
    <span fuseAlertTitle>Totul arata bine!</span>
    Formularul este valid, buna treaba!
</fuse-alert>

<form
    class="p-4 bg-card shadow rounded overflow-hidden"
    [formGroup]="basicPatientInfo">
    <mat-vertical-stepper
        [linear]="true"
        #verticalStepper>
        <mat-step
            [formGroupName]="'step1'"
            [stepControl]="basicPatientInfo.get('step1')"
            #verticalStepperStep1>
            <ng-template matStepLabel>Cine completeaza?</ng-template>
            <p class="my-2 font-medium">
                Cine urmeaza sa completeze urmatoarele formulare?
            </p>
            <div class="flex flex-col gt-xs:flex-row">
                <mat-form-field class="flex-auto gt-xs:pr-3">
                    <mat-select
                        [formControlName]="'basic_tipPersoana'"
                        [placeholder]="'Selectati'"
                        required
                        (selectionChange)="enableLegalPers($event)"
                    >
                        <mat-option [value]="CalitatePersoana.PACIENT">Pacientul</mat-option>
                        <mat-option [value]="CalitatePersoana.PARINTE">Apartinatorul - Parinte</mat-option>
                        <mat-option [value]="CalitatePersoana.APARTINATOR_SOT">Apartinatorul - Soti/Sotie</mat-option>
                        <mat-option [value]="CalitatePersoana.APARTINATOR_FRATE">Apartinatorul - Frate/sora</mat-option>
                        <mat-option [value]="CalitatePersoana.TUTORE">Apartinatorul - Tutore</mat-option>
                    </mat-select>
                    <mat-icon
                        class="icon-size-5"
                        matPrefix
                        [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                </mat-form-field>
            </div>

            <div class="flex justify-end">
                <button
                    class="px-8"
                    mat-flat-button
                    [color]="'primary'"
                    [disabled]="verticalStepperStep1.stepControl.invalid"
                    type="button"
                    (click)="this.legalPersInfReq = basicPatientInfo.get('step1').get('basic_tipPersoana').value != CalitatePersoana.PACIENT"
                    matStepperNext>
                    {{ 'Next' | transloco }}
                </button>
            </div>
        </mat-step>

        <mat-step
            [formGroupName]="'step2'"
            [stepControl]="basicPatientInfo.get('step2')"
            #verticalStepperStep2>
            <ng-template matStepLabel>Identificare persoane</ng-template>
            <p class="my-6 font-medium">
                Datele de identificare ale pacientului:
            </p>
            <div class="flex flex-col gt-xs:flex-row">
                <mat-form-field class="flex-auto gt-xs:pr-3">
                    <input
                        matInput
                        [formControlName]="'basic_prenumePacient'"
                        [placeholder]="'Prenume'"
                        (focusout)="syncField(basicPatientInfo,'step2', 'basic_prenumePacient', BasicInfoFieldNames.basic_prenumePacient)"
                        required>
                    <mat-icon
                        class="icon-size-5"
                        matPrefix
                        [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
                </mat-form-field>
                <mat-form-field class="flex-auto gt-xs:pl-3">
                    <input
                        matInput
                        [formControlName]="'basic_numePacient'"
                        [placeholder]="'Nume'"
                        (focusout)="syncField(basicPatientInfo,'step2', 'basic_numePacient', BasicInfoFieldNames.basic_numePacient)"
                        required>
                    <mat-icon
                        class="icon-size-5"
                        matPrefix
                        [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
                </mat-form-field>
                <mat-form-field class="flex-auto gt-xs:pl-3">
                    <input
                        matInput
                        [formControlName]="'basic_addrPacient'"
                        [placeholder]="'Adresa / Resedinta'"
                        (focusout)="syncField(basicPatientInfo,'step2', 'basic_addrPacient', BasicInfoFieldNames.basic_addrPacient)"
                        required>
                    <mat-icon
                        class="icon-size-5"
                        matPrefix
                        [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
                </mat-form-field>
                <mat-form-field class="flex-auto gt-xs:pr-3">
                    <mat-select
                        [formControlName]="'basic_sex'"
                        [placeholder]="'Selectati'"
                        required
                        (selectionChange)="syncField(this.basicPatientInfo,'step2', 'basic_sex', 'basic_sex');"
                    >
                        <mat-option [value]="GenderType.MALE">Masculin</mat-option>
                        <mat-option [value]="GenderType.FEMALE">Feminin</mat-option>
                    </mat-select>
                    <mat-icon
                        class="icon-size-5"
                        matPrefix
                        [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
                </mat-form-field>
                <mat-form-field class="flex-auto gt-xs:pl-3">
                    <input
                        matInput
                        [formControlName]="'basic_phone'"
                        [placeholder]="'Telefon'"
                        (focusout)="syncField(basicPatientInfo,'step2', 'basic_phone', BasicInfoFieldNames.basic_phone)"
                    >
                    <mat-icon
                        class="icon-size-5"
                        matPrefix
                        [svgIcon]="'heroicons_outline:phone'"></mat-icon>
                </mat-form-field>
                <mat-form-field class="flex-auto gt-xs:pl-3">
                    <input
                        matInput
                        [formControlName]="'basic_email'"
                        [placeholder]="'Email'"
                        (focusout)="syncField(basicPatientInfo,'step2', 'basic_email', BasicInfoFieldNames.basic_email)"
                    >
                    <mat-icon
                        class="icon-size-5"
                        matPrefix
                        [svgIcon]="'heroicons_outline:phone'"></mat-icon>
                </mat-form-field>
                <mat-form-field class="flex-auto gt-xs:pl-3">
                    <input
                        matInput
                        [formControlName]="'basic_cnpPacient'"
                        [placeholder]="'CNP'"
                        (focusout)="syncField(basicPatientInfo,'step2', 'basic_cnpPacient', BasicInfoFieldNames.basic_cnpPacient)"
                        (change)="CNPChanged()"
                    >
                    <mat-icon
                        class="icon-size-5"
                        matPrefix
                        [svgIcon]="'heroicons_outline:identification'"></mat-icon>
                </mat-form-field>
                <mat-form-field
                    class="w-full"
                    [subscriptSizing]="'dynamic'">
                    <mat-icon
                        matPrefix
                        class="hidden sm:flex icon-size-5"
                        [svgIcon]="'heroicons_solid:cake'"></mat-icon>
                    <input
                        matInput
                        readonly
                        [matDatepicker]="birthdayDatepicker"
                        [formControlName]="'basic_dateOfBirthPacient'"
                        (dateChange)="birthDayChanged()"
                        placeholder="{{ 'Birthday' | transloco }}">
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="birthdayDatepicker">
                    </mat-datepicker-toggle>
                    <mat-datepicker #birthdayDatepicker></mat-datepicker>
                </mat-form-field>
            </div>

            <ng-container *ngIf="legalPersInfReq">
                <p class="my-6 font-medium">
                    Datele de identificare ale reprezentantului legal (persoana care completeaza acest formular):
                </p>
                <div class="flex flex-col gt-xs:flex-row">
                    <mat-form-field class="flex-auto gt-xs:pr-3">
                        <input
                            matInput
                            [formControlName]="'basic_prenumeLegalPers'"
                            [placeholder]="'Prenume apartinator'"
                            (focusout)="syncField(basicPatientInfo,'step2', 'basic_prenumeLegalPers', BasicInfoFieldNames.basic_prenumeLegalPers)"
                            required>
                        <mat-icon
                            class="icon-size-5"
                            matPrefix
                            [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
                    </mat-form-field>
                    <mat-form-field class="flex-auto gt-xs:pl-3">
                        <input
                            matInput
                            [formControlName]="'basic_numeLegalPers'"
                            [placeholder]="'Nume apartinator'"
                            (focusout)="syncField(basicPatientInfo,'step2', 'basic_numeLegalPers', BasicInfoFieldNames.basic_numeLegalPers)"
                            required>
                        <mat-icon
                            class="icon-size-5"
                            matPrefix
                            [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
                    </mat-form-field>
                    <mat-form-field class="flex-auto gt-xs:pl-3">
                        <input
                            matInput
                            [formControlName]="'basic_addrLegalPers'"
                            [placeholder]="'Adresa / Resedinta'"
                            (focusout)="syncField(basicPatientInfo,'step2', 'basic_addrLegalPers', BasicInfoFieldNames.basic_addrLegalPers)"
                            required>
                        <mat-icon
                            class="icon-size-5"
                            matPrefix
                            [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
                    </mat-form-field>
                </div>

            </ng-container>
            <div class="flex justify-end mt-4">
                <button
                    class="px-8 mr-2"
                    mat-flat-button
                    [color]="'accent'"
                    type="button"
                    matStepperPrevious>
                    {{ 'Back' | transloco }}
                </button>
                <button
                    class="px-8"
                    mat-flat-button
                    [color]="'primary'"
                    [disabled]="verticalStepperStep2.stepControl.invalid"
                    type="button"
                    (click)="complete()"
                    matStepperNext>
                    {{ 'Done' | transloco }}
                </button>
            </div>
        </mat-step>
    </mat-vertical-stepper>
</form>
